import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {pointGeometryAttributeSetLike} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PointGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {GetAttributeParameters} from "#template/nodes/geometry-graph/attribute/get-attribute/geometry-get-attribute-node"
import {GeometryGetAttributeNode, getAttributeParametersSchema} from "#template/nodes/geometry-graph/attribute/get-attribute/geometry-get-attribute-node"

export type PointGeometryGetAttributeParameters = GetAttributeParameters<PointGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<PointGeometryGetAttributeParameters> = {
    nodeClass: "PointGeometryGetAttribute",
    validation: {
        parameters: getAttributeParametersSchema(pointGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryGetAttribute extends GeometryGetAttributeNode<0, PointGeometryAttributeSetLikeNode> implements PointGeometryAttributeLikeNode {
    get [pointGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
